'use client';

import { useState, useRef, useEffect, useCallback } from 'react';
// import ImageLightBox from './light-box';
import { useTranslations, useLocale } from 'next-intl';
import MediaThumbnailImages from './media-thumbnail-images';
import MediaMainSwiper from './media-main-swiper';

const Media = ({
  images,
  sku,
  product,
  title,
  description,
  price: priceWithTax,
  labels,
}) => {
  // const [openFancybox, setOpenFancybox] = useState(false);
  const [currentImg, setCurrentImg] = useState(0);
  const locale = useLocale();

  const t = useTranslations('product');

  const mainSwiperRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const thumbsRef = useRef(null);

  const hasImages = Array.isArray(images) && images.length > 0;
  const isRTL =
    typeof locale === 'string' && locale.toLowerCase().startsWith('ar');

  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  useEffect(() => {
    if (!hasImages) return;
    if (currentImg > images.length - 1) setCurrentImg(0);
  }, [images, hasImages, currentImg]);

  const handleThumbClick = useCallback((index) => {
    setCurrentImg(index);
    if (mainSwiperRef.current) {
      mainSwiperRef.current.slideTo(index);
    }
  }, []);

  if (!hasImages) {
    return (
      <div className='border-border flex h-[474px] items-center justify-center rounded-xl border bg-gray-100'>
        <p className='text-gray-500'>{t('noImagesAvailable')}</p>
      </div>
    );
  }

  return (
    <>
      <section className='flex flex-col gap-4' aria-label='Product images'>
        {/* Main image slider */}
        <MediaMainSwiper
          {...{
            thumbsSwiper,
            currentImg,
            mainSwiperRef,
            setCurrentImg,
            prevRef,
            nextRef,
            images,
            title,
            hasImages,
            isRTL,
            sku,
            product,
            description,
            // setOpenFancybox,
            t,
            priceWithTax,
            labels,
          }}
        />

        {/* Thumbnail slider */}
        <MediaThumbnailImages
          {...{
            images,
            thumbsRef,
            setThumbsSwiper,
            handleThumbClick,
            currentImg,
            title,
          }}
        />
      </section>

      {/* Lightbox modal */}
      {/* <ImageLightBox
        images={images}
        open={openFancybox}
        close={() => setOpenFancybox(false)}
        initialIndex={currentImg}
        customClassName='PDPFancyBoxContainer'
      /> */}
    </>
  );
};

export default Media;
